import MaterialTable from '@material-table/core';
import { ThemeProvider } from '@material-ui/styles';
import { tableIcons } from 'common/util/materialTable/materialTableIcons';
import { localization } from 'common/util/materialTable/localization';
import styles from './BinderTaskV2.scss';
import { viewDetails, viewDetailsColumn, DetailPanel, tasksOptions, tasksTheme } from './BinderTaskV2';
import {datesSort} from 'complionUtil/materialTable/sorting';

export const CompletedTasks = ({allCompleted, binderId, institutionId}) => {
    const completedTasksColumn = [
        {
            title: 'Recipient',
            field: 'recipient',
            cellStyle: {
                width: '30%',
                minWidth: '30%',
            },
            render: (task) =>  {
                return(
                    <div data-cy="CompletedTasks-return">
                        <p data-cy="CompletedTasks-recipient">{task.recipient}</p>
                        <div>
                            <DetailPanel 
                                totalTasks={task.detailedRecipients.length} 
                                detailedRecipients={task.detailedRecipients} />
                        </div>
                    </div>
                );
            }
        },
        {
            title: 'Type',
            field: 'documentType',
            cellStyle: {
                fontSize : '14px',
                minWidth: '20%',
            }
        },
        {
            title: 'Completed Date',
            field: 'completedDate',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center',
                paddingLeft: '0px',
                fontSize : '14px',
            },
            customSort: (row1, row2) => datesSort(row1.completedDate, row2.completedDate)
        },
        {
            title: 'Days To Complete',
            field: 'daysToComplete',
            headerStyle: {
                textAlign: 'center'
            },
            cellStyle: {
                textAlign: 'center',
                paddingLeft: '0px',
                fontSize : '14px',
            },
            render: (task) => {
                if(task.daysToComplete < 1){
                    return (
                        <div>
                            <p>Same Day</p>
                        </div>
                    );
                }
                return(
                    <div data-cy="CompletedTasks-div">
                        <p data-cy="CompletedTasks-p">{task.daysToComplete} day{task.daysToComplete > 1 ? 's' :''}</p>
                    </div>
                );
            }
        },
        viewDetailsColumn(institutionId, binderId)
    ];
    return(
        <ThemeProvider theme={tasksTheme}>
            <div data-cy="CompletedTasks-return">
                <MaterialTable 
                    options={tasksOptions}
                    icons={tableIcons}
                    data={allCompleted}
                    localization={localization}
                    onRowClick={(event, data) => viewDetails(event, data, institutionId, binderId )}
                    columns={completedTasksColumn}
                    actions={[
                        task => (
                            {hidden : 'true'}
                        )
                    ]}
                    components={
                        {
                            Action: binderRow => <div><i className={styles.check_icon} />{binderRow.daysToComplete}</div>
                        }
                    }
                />
            </div>
        </ThemeProvider>
    );
};
